import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import Header from './Header';
import { getCashPointClosingReport, downloadTarReport, getCsvReport} from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import { reportFiskalyCashPointClosingReport } from 'utils/breadcrumbInfo';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class FiskalyCashPointClosingReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `CashPointClosingReportBeginDate`);
        this.props.formInput(date, `CashPointClosingReportEndDate`);
    }

    cleanSearch = () => {
        this.props.clearFormInput(`CashPointClosingReportBeginDate`);
        this.props.clearFormInput(`CashPointClosingReportEndDate`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`fiskaly/CashPointClosingFiles?beginDate=${beginDate}&endDate=${endDate}&branchId=${branch}`, "fiskalycashPointClosingReport");
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }


    render() {
        return (
            <Grid headerContent={reportFiskalyCashPointClosingReport}>
                <PageHeader title={LOOKUP.report.FiskalyCashPointClosingReport.text} 
                    description={LOOKUP.report.FiskalyCashPointClosingReport.description}
                />
                <Header
                    branchOptions = {this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                />
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    return {
        branchOptions: branchOptions,
        fiskalyCashPointClosingReport: state.reports.fiskalyCashPointClosingReport,
        loggedBranch: state.common.branchId,
        branch: state.form.CashPointClosingReportBranchOption,
        beginDate: state.form.CashPointClosingReportBeginDate,
        endDate: state.form.CashPointClosingReportEndDate
    };
};

const mapDispatchToProps = dispatch => {
    return {
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(FiskalyCashPointClosingReport));